import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-slate-900 py-12 text-center text-slate-500 text-sm border-t border-slate-800" data-id="element-51">
        <div className="container mx-auto px-4" data-id="element-52">
          <p className="mb-4" data-id="element-53">
            &copy; {new Date().getFullYear()} Cero Pánico de Deudas. Todos los
            derechos reservados.
          </p>
          <div className="flex items-center justify-center gap-4 mb-4" data-id="element-54">
            <button onClick={() => setActiveModal('privacy')} className="text-slate-400 hover:text-white transition-colors underline underline-offset-2" data-id="element-55">
              Política de Privacidad
            </button>
            <span className="text-slate-700" data-id="element-56">•</span>
            <button onClick={() => setActiveModal('terms')} className="text-slate-400 hover:text-white transition-colors underline underline-offset-2" data-id="element-57">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-xs text-slate-600" data-id="element-58">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera.
          </p>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-59">
        <p className="font-semibold text-slate-800" data-id="element-60">
          Última actualización: Febrero 2026
        </p>

        <p data-id="element-61">
          En Cero Pánico de Deudas, respetamos tu privacidad y nos comprometemos
          a proteger la información personal que compartas con nosotros.
        </p>

        <h3 className="font-bold text-slate-800 pt-2" data-id="element-62">
          1. Información que recopilamos
        </h3>
        <p data-id="element-63">
          Recopilamos únicamente la información necesaria para procesar tu
          compra: nombre, correo electrónico y datos de pago. No almacenamos
          datos de tarjetas de crédito directamente; estos son procesados por
          plataformas de pago seguras.
        </p>

        <h3 className="font-bold text-slate-800 pt-2" data-id="element-64">
          2. Uso de la información
        </h3>
        <p data-id="element-65">Tu información se utiliza exclusivamente para:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-66">
          <li data-id="element-67">Entregar el producto digital adquirido.</li>
          <li data-id="element-68">Enviar confirmaciones de compra y acceso al material.</li>
          <li data-id="element-69">Atender solicitudes de soporte o garantía.</li>
        </ul>

        <h3 className="font-bold text-slate-800 pt-2" data-id="element-70">
          3. Compartir información
        </h3>
        <p data-id="element-71">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros, excepto cuando sea necesario para procesar pagos o cumplir
          con obligaciones legales.
        </p>

        <h3 className="font-bold text-slate-800 pt-2" data-id="element-72">4. Seguridad</h3>
        <p data-id="element-73">
          Implementamos medidas de seguridad razonables para proteger tu
          información. Sin embargo, ningún método de transmisión por internet es
          100% seguro.
        </p>

        <h3 className="font-bold text-slate-800 pt-2" data-id="element-74">5. Tus derechos</h3>
        <p data-id="element-75">
          Puedes solicitar la eliminación de tus datos personales en cualquier
          momento escribiéndonos directamente. Atenderemos tu solicitud en un
          plazo máximo de 10 días hábiles.
        </p>
      </LegalModal>

      {/* Terms Modal */}
      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-76">
        <p className="font-semibold text-slate-800" data-id="element-77">
          Última actualización: Febrero 2026
        </p>

        <p data-id="element-78">
          Al adquirir "Cero Pánico de Deudas", aceptas los siguientes términos y
          condiciones. Por favor, léelos con atención antes de realizar tu
          compra.
        </p>

        <h3 className="font-bold text-slate-800 pt-2" data-id="element-79">1. Producto digital</h3>
        <p data-id="element-80">
          "Cero Pánico de Deudas" es un producto digital educativo que incluye
          un PDF, plantillas de Google Sheets y scripts de comunicación. No
          constituye asesoría financiera, legal ni profesional personalizada.
        </p>

        <h3 className="font-bold text-slate-800 pt-2" data-id="element-81">2. Entrega</h3>
        <p data-id="element-82">
          El acceso al material se entrega de forma inmediata tras confirmar el
          pago. Recibirás un correo electrónico con los enlaces de descarga y
          acceso.
        </p>

        <h3 className="font-bold text-slate-800 pt-2" data-id="element-83">3. Garantía de 7 días</h3>
        <p data-id="element-84">
          Ofrecemos una garantía de devolución de 7 días. Para solicitar el
          reembolso, debes demostrar que completaste las plantillas incluidas en
          el sistema. Esto no es un castigo; es para asegurar que realmente
          usaste el material.
        </p>

        <h3 className="font-bold text-slate-800 pt-2" data-id="element-85">4. Uso permitido</h3>
        <p data-id="element-86">
          El material es para uso personal. Queda prohibida su reproducción,
          distribución o reventa sin autorización expresa por escrito.
        </p>

        <h3 className="font-bold text-slate-800 pt-2" data-id="element-87">
          5. Limitación de responsabilidad
        </h3>
        <p data-id="element-88">
          Los resultados dependen del esfuerzo y la situación individual de cada
          persona. No garantizamos resultados financieros específicos. El
          material es una herramienta educativa, no un servicio de asesoría
          financiera.
        </p>

        <h3 className="font-bold text-slate-800 pt-2" data-id="element-89">6. Modificaciones</h3>
        <p data-id="element-90">
          Nos reservamos el derecho de actualizar estos términos. Cualquier
          cambio será comunicado a los compradores por correo electrónico.
        </p>
      </LegalModal>
    </>;
}